(function ($, window) {
    $(document).ready(function () {
        window.bol = {
            types: {}
        };
    });
})($jq, window);


(function ($, window) {
    $(document).ready(function () {
        window.bol.types.ResetPasswordForm = function (formElement) {
            if (formElement.length > 0) {
                this.init(formElement);
            }
        };

        $.extend(window.bol.types.ResetPasswordForm.prototype, {
            init: function (formElement) {
                this.form = $(formElement);
                this.AuthenticationToken = this.form.find('#AuthenticationToken');
                this.txtPassword = this.form.find('#txtPassword');
                this.txtConfirmPassword = this.form.find('#txtConfirmPassword');
                this.url = this.form.attr('action');
                this.method = this.form.attr('method');
                this.resetPasswordSuccess = this.form.find('#success-message');
                this.resetPasswordFailure = this.form.find('#error-message');
                this.form.on('submit', function (e) {
                    e.preventDefault();
                });

                var me = this;

                formElement.submit(function (event) {

                    event.preventDefault();
                    event.stopImmediatePropagation();
                    try {
                        me.form.validator();
                        if (me.form[0].checkValidity()) {
                            me.submit();
                        }
                    } catch (e) {/*do nothing*/ }

                    return false;
                });
            },

            showSuccess: function (show) {
                if (show) {
                    this.resetPasswordSuccess.removeClass('hidden');
                } else {
                    this.resetPasswordSuccess.addClass('hidden');
                }
            },

            showError: function (show) {
                if (show) {
                    this.resetPasswordFailure.removeClass('hidden');
                } else {
                    this.resetPasswordFailure.addClass('hidden');
                }
            },


            submit: function () {
                var me = this;

                me.showSuccess(false);
                me.showError(false);

                $.ajax({
                    url: me.url,
                    type: me.method,
                    dataType: "json",
                    contentType: "application/json",
                    data: JSON.stringify({
                        AuthenticationToken: me.AuthenticationToken.val(),
                        txtPassword: me.txtPassword.val(),
                        txtConfirmPassword: me.txtConfirmPassword.val()
                    }),
                    success: function (result) {
                        if (result.success) {
                            me.showSuccess(true);
                            return false;
                        } else {
                            me.showError(true);
                            return false;
                        }
                    },
                    error: function () {
                        me.showError(true);
                        return false;
                    }
                });
                return false;
            }
        });

        window.bol.resetPasswordForm = new window.bol.types.ResetPasswordForm($('#form.common--login-form__reset'));
    });
})($jq, window);
